export const Key = () => {
  const key = (Math.random() + 1).toString(36).substring(7);
  return key;
};

export default Key;
